import { jsx as _jsx } from "react/jsx-runtime";
import { pickingActions, pickingApi } from '@/warehouse/modules/picking/business';
import { NavLink, Navigate, redirect } from 'react-router-dom';
import { t } from '@/core/localization';
import { Skeleton } from '@/core/ui';
import { store } from '@/warehouse/store';
import { formatDate } from 'date-fns';
import { appSections } from '../appSections';
import { ProtectedRoute } from '../components';
import { initPickingTasks } from './thunks';
const { rootPath, getLinkTo, title, groups } = appSections.picking;
export const pickingRoutes = [
    {
        path: rootPath,
        element: _jsx(Navigate, { to: "tasks", replace: true }),
    },
    {
        path: rootPath,
        lazy: async () => {
            const { PickingContainer } = await import('@/warehouse/modules/picking');
            return {
                element: (_jsx(ProtectedRoute, { groups: groups, children: _jsx(PickingContainer, {}) })),
            };
        },
        loader: () => store.dispatch(pickingActions.clearTaskDetails()),
        handle: {
            crumb: ({ params: { locationId } }) => _jsx(NavLink, { to: getLinkTo(locationId), children: title }),
        },
        children: [
            {
                path: ':tab',
                lazy: async () => {
                    const { Picking } = await import('@/warehouse/modules/picking');
                    return { Component: Picking };
                },
                loader: ({ params: { tab } }) => {
                    // TODO: add this check in all places in the project when it is required. Check for numbers and constants.
                    // if (tab !== 'invoices' && tab !== 'verification' && isNaN(Number(tab))) return redirect('/notfound');
                    if (tab !== 'tasks' && tab !== 'verification')
                        return redirect('/notfound');
                    store.dispatch(initPickingTasks());
                },
                handle: {
                    crumb: ({ params: { locationId, tab } }) => (_jsx(NavLink, { to: `${getLinkTo(locationId)}/${tab}`, children: tab === 'tasks' ? t('incoming.label') : tab === 'verification' ? t('verification.label') : 'UNKNOWN' })),
                },
            },
            {
                path: ':tab/:taskId',
                lazy: async () => {
                    const { PickingTask } = await import('@/warehouse/modules/picking/components/PickingTask');
                    return { Component: PickingTask };
                },
                loader: async ({ params }) => {
                    const taskId = Number(params?.taskId);
                    try {
                        if (isNaN(taskId))
                            return;
                        const { task } = await store.dispatch(pickingApi.endpoints.getPickingTaskItems.initiate({ taskId })).unwrap();
                        const taskDetails = {
                            id: task.id,
                            stockName: task.stockName,
                            createDate: task.createDate,
                        };
                        store.dispatch(pickingActions.setTaskDetails(taskDetails));
                    }
                    catch (error) {
                        console.error('Picking details loading... Error: ', error);
                    }
                },
                handle: {
                    crumb: ({ params: { locationId, taskId } }) => {
                        const taskDetails = store.getState().picking.taskDetails;
                        if (!taskDetails)
                            return (_jsx(NavLink, { to: `${getLinkTo(locationId)}/tasks/${taskId}`, children: _jsx(Skeleton, { width: 400 }) }));
                        return _jsx(NavLink, { to: `${getLinkTo(locationId)}/tasks/${taskId}`, children: getPickingTaskHeaderText(taskDetails) });
                    },
                },
            },
        ],
    },
];
function getPickingTaskHeaderText(taskDetails) {
    const { createDate, stockName } = taskDetails;
    return `${t('picking.task.label')} ${stockName} ${t('dated.label')} ${formatDate(createDate, 'dd MMMM yyyy г. в HH:mm')}`;
}
